var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { clearable: "", placeholder: "请输入管理员名称" },
            model: {
              value: _vm.listQuery.username,
              callback: function($$v) {
                _vm.$set(_vm.listQuery, "username", $$v)
              },
              expression: "listQuery.username"
            }
          }),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { clearable: "", placeholder: "请输入管理员账号" },
            model: {
              value: _vm.listQuery.userAccount,
              callback: function($$v) {
                _vm.$set(_vm.listQuery, "userAccount", $$v)
              },
              expression: "listQuery.userAccount"
            }
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: ["GET /admin/admin/list"],
                  expression: "['GET /admin/admin/list']"
                }
              ],
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter }
            },
            [_vm._v("查找")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: ["POST /admin/admin/create"],
                  expression: "['POST /admin/admin/create']"
                }
              ],
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-edit" },
              on: { click: _vm.handleCreate }
            },
            [_vm._v("添加")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading"
            }
          ],
          attrs: {
            data: _vm.list,
            "element-loading-text": "正在查询中。。。",
            border: "",
            fit: "",
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { align: "center", label: "登录名称", prop: "userName" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "登录账号", prop: "userAccount" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "邮箱地址", prop: "email" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "话务系统工号", prop: "qiYu" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "话务系统分机号", prop: "extNo" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "权限角色", prop: "roleIds" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.roleIds, function(roleId) {
                    return _c(
                      "el-tag",
                      {
                        key: roleId,
                        staticStyle: { "margin-right": "20px" },
                        attrs: { type: "primary" }
                      },
                      [_vm._v(" " + _vm._s(_vm.formatRole(roleId)) + " ")]
                    )
                  })
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "账号类型", prop: "type" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.type == 0
                      ? _c("el-tag", { attrs: { type: "primary" } }, [
                          _vm._v("CSR-400")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.type == 1
                      ? _c("el-tag", { attrs: { type: "danger" } }, [
                          _vm._v("CSR-OB")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.type == 2
                      ? _c("el-tag", { attrs: { type: "danger" } }, [
                          _vm._v("TL")
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "状态", prop: "state" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.state == 1
                      ? _c("el-tag", { attrs: { type: "danger" } }, [
                          _vm._v("冻结")
                        ])
                      : _c("el-tag", [_vm._v("正常")])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "操作",
              "class-name": "small-padding fixed-width"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["POST /admin/admin/update"],
                            expression: "['POST /admin/admin/update']"
                          },
                          {
                            name: "show",
                            rawName: "v-show",
                            value: scope.row.state == 0,
                            expression: "scope.row.state == 0"
                          }
                        ],
                        attrs: {
                          type: "text",
                          icon: "el-icon-edit",
                          size: "mini"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleUpdate(scope.row)
                          }
                        }
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["POST /admin/admin/delete"],
                            expression: "['POST /admin/admin/delete']"
                          },
                          {
                            name: "show",
                            rawName: "v-show",
                            value: scope.row.state == 0,
                            expression: "scope.row.state == 0"
                          }
                        ],
                        staticStyle: { color: "red" },
                        attrs: {
                          type: "text",
                          icon: "el-icon-close",
                          size: "mini"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleDelete(scope.row)
                          }
                        }
                      },
                      [_vm._v("停用")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: ["POST /admin/admin/enable"],
                            expression: "['POST /admin/admin/enable']"
                          },
                          {
                            name: "show",
                            rawName: "v-show",
                            value: scope.row.state == 1,
                            expression: "scope.row.state == 1"
                          }
                        ],
                        staticStyle: { color: "red" },
                        attrs: {
                          type: "text",
                          icon: "el-icon-check  ",
                          size: "mini"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleEnable(scope.row)
                          }
                        }
                      },
                      [_vm._v("启用")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0"
          }
        ],
        attrs: {
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit
        },
        on: {
          "update:page": function($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList
        }
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.textMap[_vm.dialogStatus],
            visible: _vm.dialogFormVisible,
            width: "660px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              staticStyle: { width: "500px", "margin-left": "50px" },
              attrs: {
                rules: _vm.rules,
                model: _vm.dataForm,
                "status-icon": "",
                "label-position": "left",
                "label-width": "100px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "登录名称",
                    prop: "userName",
                    placeholder: "显示名 可以是中文"
                  }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.dataForm.userName,
                      callback: function($$v) {
                        _vm.$set(_vm.dataForm, "userName", $$v)
                      },
                      expression: "dataForm.userName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "登录账号", prop: "userAccount" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "最少6位字符，必须英文或者数字" },
                    model: {
                      value: _vm.dataForm.userAccount,
                      callback: function($$v) {
                        _vm.$set(_vm.dataForm, "userAccount", $$v)
                      },
                      expression: "dataForm.userAccount"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticStyle: { color: "red", "font-size": "12px" } },
                    [_vm._v("最少6位字符")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.dialogStatus == "create"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "登录密码", prop: "userPassword" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "password",
                          placeholder:
                            "至少6位，包含大写字母、小写字母、数字、特殊字符",
                          "auto-complete": "off"
                        },
                        model: {
                          value: _vm.dataForm.userPassword,
                          callback: function($$v) {
                            _vm.$set(_vm.dataForm, "userPassword", $$v)
                          },
                          expression: "dataForm.userPassword"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "邮箱地址", prop: "email" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.dataForm.id == 1,
                      type: "email",
                      placeholder: "用来接收报表"
                    },
                    model: {
                      value: _vm.dataForm.email,
                      callback: function($$v) {
                        _vm.$set(_vm.dataForm, "email", $$v)
                      },
                      expression: "dataForm.email"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "联系方式", prop: "mobile" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "联系方式", "auto-complete": "off" },
                    model: {
                      value: _vm.dataForm.mobile,
                      callback: function($$v) {
                        _vm.$set(_vm.dataForm, "mobile", $$v)
                      },
                      expression: "dataForm.mobile"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "话务系统工号", prop: "qiYu" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入话务系统工号" },
                    model: {
                      value: _vm.dataForm.qiYu,
                      callback: function($$v) {
                        _vm.$set(_vm.dataForm, "qiYu", $$v)
                      },
                      expression: "dataForm.qiYu"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "话务系统分机号", prop: "extNo" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入分机号" },
                    model: {
                      value: _vm.dataForm.extNo,
                      callback: function($$v) {
                        _vm.$set(_vm.dataForm, "extNo", $$v)
                      },
                      expression: "dataForm.extNo"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "分机登录密码", prop: "extPwd" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入分机的登录密码" },
                    model: {
                      value: _vm.dataForm.extPwd,
                      callback: function($$v) {
                        _vm.$set(_vm.dataForm, "extPwd", $$v)
                      },
                      expression: "dataForm.extPwd"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "权限角色", prop: "roleIds" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "400px" },
                      attrs: { multiple: "", placeholder: "请选择" },
                      model: {
                        value: _vm.dataForm.roleIds,
                        callback: function($$v) {
                          _vm.$set(_vm.dataForm, "roleIds", $$v)
                        },
                        expression: "dataForm.roleIds"
                      }
                    },
                    _vm._l(_vm.roleOptions, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "技能角色", prop: "type" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "400px" },
                      attrs: { placeholder: "请选择技能角色" },
                      model: {
                        value: _vm.dataForm.type,
                        callback: function($$v) {
                          _vm.$set(_vm.dataForm, "type", $$v)
                        },
                        expression: "dataForm.type"
                      }
                    },
                    _vm._l(_vm.skills, function(item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogFormVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _vm.dialogStatus == "create"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.createData }
                    },
                    [_vm._v("确定")]
                  )
                : _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.updateData }
                    },
                    [_vm._v("确定")]
                  )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }